<template>
    <div class="box-loader" :class="{ 'screen-page': isLoadingPage }">
        <span :class="[ isLoadingWhiteColor ? 'white__loading': 'loader']"></span>
    </div>
</template>
<script>
export default {
    props: {
        isLoadingPage: {
            type: Boolean,
            default: true,
        },
        isLoadingWhiteColor: {
          type: Boolean,
          default: false,
        },
    },
    data() {
        return {}
    },
    methods: {},
}
</script>

<style lang="scss">
@import '~ThemePath/scss/common/_loading.scss';
</style>
